import { EdgeTube3D } from './EdgeTube3D';
import type { Graph3DEdgeRendererProps } from '../../core/renderer.types';

export function FlowEdge3D(props: Graph3DEdgeRendererProps) {
  return <EdgeTube3D {...props} runtime={props.runtime} />;
}
